// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CostCenterLocationDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CostCenterLocationApiClient extends BaseCRUDApiClient<CostCenterLocationDto> {
  baseUrl = this.config.apiEndpoint + '/cost-center-location';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  hasCdcCoordinator(entity: CostCenterLocationDto) {
    return this.http.post<boolean>(`${this.baseUrl}/has-cdc-coordinator`, {
      entity,
    });
  }
  hasCdcDirector(entity: CostCenterLocationDto) {
    return this.http.post<boolean>(`${this.baseUrl}/has-cdc-director`, {
      entity,
    });
  }
  hasMUDirector(entity: CostCenterLocationDto) {
    return this.http.post<boolean>(`${this.baseUrl}/has-mu-director`, {
      entity,
    });
  }

  getSicCostCenterLocation() {
    return this.http.get<CostCenterLocationDto>(
      `${this.baseUrl}/get-sic-cdc-location`,
    );
  }
}
